<div class="text-center mt-5">
    <h1>Payment Successful</h1>
    <p>You have successfuly purchased a portal product</p>
    <a class="btn btn-primary" [routerLink]="['/']">Return to Home</a>
  </div>
